import styled from "styled-components"
import { primaryColor, tertiaryColor } from "../../../styles/variables";

const CalculatorContainer = styled.section`
.calculator {
    height: 320px;
    width: 235px;
    border-radius: 7px;
    overflow: hidden;
    background-color: ${tertiaryColor};
    display: grid;
    grid-template-columns: repeat(4, 25%);
    grid-template-rows: 1fr repeat(5, 48px);
}
`;

const CalculatorButtons = styled.button`
    font-size: 1.8em;
    background-color: ${primaryColor};
    border: none;
    border-right: ${primaryColor};
    border-bottom: ${primaryColor};
    outline: none;

    

    &:active {
    background-color: #ccc;
}
    .double {
    grid-column: span 2;
    }
    .triple {
    grid-column: span 3;
}
.operation {
    background-color: #c4ce37;
    color: #fff;
}

&.operation:active {
    background-color: #a7af2e;
}

`;


const CalculatorDisplay = styled.div`
    grid-column: span 4;
    background-color: #0007;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 20px;
    font-size: 2rem;
    
`;

export { CalculatorContainer, CalculatorButtons, CalculatorDisplay }